import { render, staticRenderFns } from "./MailManagePanel.vue?vue&type=template&id=4cf90b23&scoped=true&"
import script from "./MailManagePanel.vue?vue&type=script&lang=ts&"
export * from "./MailManagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./MailManagePanel.vue?vue&type=style&index=0&id=4cf90b23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf90b23",
  null
  
)

export default component.exports